import React, { useEffect } from 'react';


const TimerTracker = ({ setInactiveTab }) => {

    const debouncedCallApi = () =>{
        setInactiveTab(true);
        setTimeout(() => {
            setInactiveTab(false);
        },200);
    }

    useEffect(() => {
        const handleVisibilityChange = () => {
          if (document.visibilityState === 'hidden') {
            debouncedCallApi();
          }
        };
    
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange); 
        };
      }, []);


    return null
};

export default TimerTracker;